<template functional>
  <svg
    class="overlay remove-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 300 300"
    width="50%"
    height="50%"
    style="vertical-align: middle;"
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M150,0A150 150 0 1 0 150,300A150 150 0 1 0 150,0Z       M75.586,54.102A121.429 121.429 0 0 1 150,28.571A121.429 121.429 0 0 1 271.429,150A121.429 121.429 0 0 1 245.898,224.414Z       M224.414,245.898A121.429 121.429 0 0 1 150,271.429A121.429 121.429 0 0 1 28.571,150A121.429 121.429 0 0 1 54.102,75.586Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'RemoveIcon',
};
</script>

<style scoped>
.remove-icon {
  max-width: 136px;
}

svg path {
  fill: rgb(206, 212, 218);
}

.selected svg path {
  fill: #0baaff;
}
</style>
